import { useLayoutEffect, useState } from 'react';

const PREVENT_SCROLL_ATTRIBUTE = 'data-prevent-scroll';
const SCROLL_POSITION_KEY = 'scroll-position';

export const isLocked = () => document.body.getAttribute(PREVENT_SCROLL_ATTRIBUTE) === 'true';

const useScrollLock = () => {
    const [initialScrollPosition, setInitialScrollPosition] = useState(0);

    const lockScroll = () => {
        if (!isLocked()) {
            const body = document.body;
            const scrollPosition = window.pageYOffset;
            body.style.position = 'fixed';
            body.style.overflowY = 'scroll';
            body.style.width = '100%';
            body.setAttribute(PREVENT_SCROLL_ATTRIBUTE, 'true');
            localStorage.setItem(SCROLL_POSITION_KEY, scrollPosition.toString());
            body.style.top = `-${localStorage.getItem(SCROLL_POSITION_KEY)}px`;
            setInitialScrollPosition(scrollPosition);
        }
    };

    const unlockScroll = () => {
        if (isLocked()) {
            const body = document.body;
            const storedScrollPosition = localStorage.getItem(SCROLL_POSITION_KEY);
            const parsedScrollPosition = storedScrollPosition === null ? Number.NaN : parseFloat(storedScrollPosition);
            const scrollPosition = Number.isFinite(parsedScrollPosition) ? parsedScrollPosition : initialScrollPosition;
            body.style.removeProperty('position');
            body.style.removeProperty('overflowY');
            body.style.removeProperty('top');
            body.style.removeProperty('width');
            window.scrollTo({ top: scrollPosition });
            body.removeAttribute(PREVENT_SCROLL_ATTRIBUTE);
            localStorage.removeItem(SCROLL_POSITION_KEY);
        }
    };

    useLayoutEffect(() => {
        setInitialScrollPosition(window.pageYOffset);

        if (isLocked()) {
            const storedScrollPosition = localStorage.getItem(SCROLL_POSITION_KEY);
            const scrollPosition = storedScrollPosition === null ? 0 : parseFloat(storedScrollPosition) || 0;
            document.body.style.top = `-${scrollPosition}px`;
        } else {
            localStorage.removeItem(SCROLL_POSITION_KEY);
        }
    }, []);

    return { isLocked, lockScroll, unlockScroll };
};

// Login keeps the page position in scroll lock until the overlay closes.
// Zero has to be stored explicitly, otherwise unlock falls back to the old position.
export const resetScrollLockToTop = () => {
    if (typeof document === 'undefined' || !isLocked()) {
        return;
    }

    localStorage.setItem(SCROLL_POSITION_KEY, '0');
    document.body.style.top = '0px';
};

export default useScrollLock;
